/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
export { SeverityNumber } from './types/LogRecord';
export { NOOP_LOGGER, NoopLogger } from './NoopLogger';
import { LogsAPI } from './api/logs';
export const logs = LogsAPI.getInstance();
//# sourceMappingURL=index.js.map